__turbopack_context__.v({
  "label": "FloatingLabel-module__520vVa__label",
  "labelFloat": "FloatingLabel-module__520vVa__labelFloat",
});
